import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
	FormBuilder,
	FormGroup,
	FormControl,
	Validators
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { DepartmentService } from 'src/app/core/services/department.service';

import { AuthenticationService } from '../../core/services/authentication.service';
import { SettingService } from '../../core/services/setting.service';

import { MustMatch } from './../../core/helpers/must-match.validator';
import { environment } from 'src/environments/environment';
import { CategorymasterService } from 'src/app/core/services/categorymaster.service';
import { ClientService } from 'src/app/core/services/client.service';
import { UserService } from 'src/app/core/services/user.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Token } from '../../shared/models/token.model';
import { User } from '../../shared/models/user.model';
import { NgxRolesService, NgxPermissionsService } from 'ngx-permissions';



@Component({
	selector: 'app-register',
	templateUrl: './register.component.html',
	styleUrls: ['./register.component.scss']
})

export class RegisterComponent implements OnInit {
	private apiUrl = environment.apiUrl;
	registerForm: FormGroup;
	settings: any;
	otpForm!: FormGroup;
	emailKey = '';         // Email captured during registration
	otpVerified = false;
	backgroundImage: string;
	isSettingsLoad = false;
	isFormSubmitted = false;
	categorymaster: any = [];
	selectedDepartmentRoles: any;
	defaultDepartmentRoles = [
		{ department_id: 1, role_id: 3 }
	];
	departmentsRoles: any = [];

	otpCode: string | null = null;
	otpEmail: string | null = null;
	private currentTokenSubject: BehaviorSubject<Token>;
	private currentUserSubject: BehaviorSubject<User>;
	public loginUser: Observable<User>;
	public loginToken: Observable<Token>;
	loginCurrentUser: any;
	userAccessToken: any;
	showOtpScreen = false;
	tempUserData: any = {};
	emailMessage: string;
	// staticOtp = '123456';

	constructor(
		public translate: TranslateService,
		private router: Router,
		private formBuilder: FormBuilder,
		private toastr: ToastrService,
		private authenticationService: AuthenticationService,
		private settingService: SettingService,
		private categorymasterService: CategorymasterService,
		private clientService: ClientService,
		private userService: UserService,
		private departmentService: DepartmentService,
		public ngxRolesService: NgxRolesService,
		public ngxPermissionsService: NgxPermissionsService

		//  private otpService: OtpService

	) {
		if (localStorage.getItem('loginUser')) {
			this.loginCurrentUser = JSON.parse(localStorage.getItem('loginUser'));

			//this.userAccessToken = JSON.parse(localStorage.getItem('token'));
			// token is NOT JSON → do NOT parse
			this.userAccessToken = localStorage.getItem('token');
		}
		this.currentTokenSubject = new BehaviorSubject<Token>(this.userAccessToken);
		this.currentUserSubject = new BehaviorSubject<User>(this.loginCurrentUser);
		this.loginUser = this.currentUserSubject.asObservable();
		this.loginToken = this.currentTokenSubject.asObservable();
	}

	public get currentUserValue(): User {
		return this.currentUserSubject.value;
	}

	public get currentTokenValue(): Token {
		return this.currentTokenSubject.value;
	}

	setLoginUser(user) {
		localStorage.setItem('loginUser', JSON.stringify(user));
		this.setUserPermissions(user);
		this.currentUserSubject.next(user);
	}


	setUserPermissions(user) {
		this.ngxRolesService.flushRoles();
		this.ngxPermissionsService.flushPermissions();

		localStorage.setItem("permissions", JSON.stringify(user));

		for (let iRow in user.permissions) {
			this.ngxPermissionsService.addPermission(user.permissions[iRow]);
		}
		this.ngxRolesService.addRoles(user.permissions);
	}

	getToken() {
		return localStorage.getItem('token')
	}

	ngOnInit() {
		this.getSettings();
		this.loadForm();
		// this.getCategorymaster();
		this.getDepartments();
		this.loadOtpForm()
	}

	loadForm() {
		this.registerForm = this.formBuilder.group({
			fullName: ['', [Validators.required]],
			email: ['', [Validators.required, Validators.email]],
			//userType : ['business_account'],
			password: ['', [Validators.required, Validators.minLength(8), Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).+$')]],
			contact: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
			userType: ['business_account']
			//userBusinessRoleId : [1]
		});

	}

	loadOtpForm() {
		this.otpForm = this.formBuilder.group({
			d0: [''],
			d1: [''],
			d2: [''],
			d3: ['']
		})
	}

	otpLength = 4;

	onOtpInput(event: any, index: number) {
		const input = event.target;
		const value = input.value;

		// allow only numbers
		if (!/^\d$/.test(value)) {
			input.value = '';
			return;
		}

		// move to next input
		if (value && index < this.otpLength - 1) {
			const next = input.nextElementSibling;
			if (next) {
				next.focus();
			}
		}
	}

	onKeyDown(event: KeyboardEvent, index: number) {
		const input = event.target as HTMLInputElement;

		// BACKSPACE handling
		if (event.key === 'Backspace') {
			if (!input.value && index > 0) {
				const prev = input.previousElementSibling as HTMLInputElement;
				if (prev) {
					prev.focus();
					prev.value = '';
					this.otpForm.get(`d${index - 1}`).setValue('');
				}
			}
		}
	}

	onPaste(event: ClipboardEvent) {
		event.preventDefault();

		const pasteData = event.clipboardData.getData('text') || '';
		const digits = pasteData.replace(/\D/g, '').slice(0, this.otpLength);

		if (!digits) return;

		digits.split('').forEach((digit, i) => {
			this.otpForm.get(`d${i}`).setValue(digit);
		});

		// focus last filled input
		const inputs = document.querySelectorAll('.otp-inputs input');
		const focusIndex = Math.min(digits.length, this.otpLength) - 1;
		(inputs[focusIndex] as HTMLInputElement).focus();
	}


	checkEmail() {
		// const payload = {
			
		// };

		this.authenticationService.verifyEmail(this.registerForm.value.email).subscribe(
			(res: boolean) => {
				if (res === true) {
					this.emailMessage = 'Email already exists';
				} else {
					this.emailMessage = ''; // clear message if no duplicate
				}
			},
			(err) => {
				console.error(err);
				this.emailMessage = ''; // clear message on error too
			}
		);
	}


	// user_generated_id: ['USR0001', Validators.required],
	// firstname: ['firstname', Validators.required],
	// lastname: ['lastnametest', Validators.required],
	// password_confirmation: ['', Validators.required],
	// skype: [''],
	// country: [null],
	// mobile: ['', Validators.pattern(/^(?:[+])?(\d[ -]?){1,15}$/)],
	// language: ['en'],
	// address: [''],
	// avatar: [null],
	// gst_no: [''],
	// aadhar_no: [''],
	// industry_types: [''],
	// department_roles: [this.departmentsRoles, Validators.required]
	// , clients: this.formBuilder.group({
	// 	company_name: [''],
	// 	company_email: ['', [Validators.email]],
	// 	company_phone: ['', Validators.pattern(/^(?:[+])?(\d[ -]?){1,15}$/)],
	// 	company_mobile: ['', [Validators.pattern(/^(?:[+])?(\d[ -]?){1,15}$/)]],
	// 	company_zipcode: [''],
	// 	company_city: [''],
	// 	company_country: [null],
	// 	company_fax: [''],
	// 	company_address: [''],
	// 	website: ['', Validators.pattern(/[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/)],
	// 	skype_id: [''],
	// 	facebook: [''],
	// 	twitter: [''],
	// 	linkedin: [''],
	// 	hosting_company: [''],
	// 	host_name: [''],
	// 	host_username: [''],
	// 	host_password: [''],
	// 	host_port: [''],

	// 	})

	// 	{
	// 		validator: MustMatch('password', 'password_confirmation')
	// 	});

	// this.getUserGeneratedId();

	get userControl() { return this.registerForm.controls; }

	getSettings() {
			this.settings = this.settingService.getSettings();
			if (!this.settings.allowed_for_registration) {
				this.router.navigate(['login']);
			}
			this.setBGImage();
			this.isSettingsLoad = true;

	}

	setBGImage() {
		if (this.settings.login_background) {
			this.backgroundImage = this.apiUrl + '/uploads/login_bg/' + this.settings.login_background;
		} else {
			this.backgroundImage = 'assets/img/login-bg-2.png';
		}
	}
	allowOnlyDigits(event: any) {
		event.target.value = event.target.value.replace(/[^0-9]/g, '');
	}

	onSubmit() {
		this.isFormSubmitted = true;

		if (this.registerForm.invalid) {
			return;
		}
		this.toastr.success(
			this.translate.instant('OTP SEND'),
			this.translate.instant('CHECK YOUR EMAIL')

		);
		this.showOtpScreen = true;
		this.authenticationService.register(this.registerForm.value).subscribe((data) => {
			this.emailKey = this.registerForm.value.email;
			console.log('OTP sent to:', this.emailKey);

			this.router.navigate(['login']);
		})

		// if(this.registerForm){
		// 	this.sendOtp;
		// }
	}


	// 	this.authenticationService.registerOtp(email).subscribe({
	// 	next: (response) => {
	// 		if (response) {
	// 			// this.otpCode = response.otp;
	// 			// this.otpEmail = response.key;
	// 			console.log(`OTP for ${this.otpEmail}: ${this.otpCode}`);
	// 		} else {
	// 			console.warn('Invalid OTP response');
	// 		}
	// 	},
	// 	error: (err) => {
	// 		console.error('Error sending OTP:', err);
	// 	}
	// });

	// Start with default value
	// const departmentRoles = this.defaultDepartmentRoles;

	// Then add selected ones if any
	// if (this.selectedDepartmentRoles) {
	// 	for (let iRow of this.selectedDepartmentRoles) {
	// 		if (iRow.pivot) {
	// 			departmentRoles.push(iRow.pivot);
	// 		}
	// 	}
	// }

	// ✅ Update form control properly
	// this.registerForm.get('department_roles').setValue(departmentRoles);


	// Submit with the complete value
	// this.clientService.create(this.registerForm.value)
	// 	.subscribe((data) => {
	// 		this.toastr.success(
	// 			this.translate.instant('register.messages.success'),
	// 			this.translate.instant('register.title')
	// 		);
	// 		this.router.navigate(['login']);
	// 	});


	// 🚧 Placeholder for backend OTP service
	// this.otpService.sendOtp(this.tempUserData.email).subscribe();
	// this.authenticationService.registerOtp



	// sendOtp(email: string) {

	// }


	// 	getCategorymaster(isLoad = false) {
	// 	this.categorymasterService.getAll().subscribe(data => {
	// 		this.categorymaster = data;
	// 		 // Filter based on selected tab	
	// 	});
	// }

	// getCategorymaster(isLoad = false) {
	// 	this.categorymasterService.getAll().subscribe(data => {
	// 		// Filter only items where form_name is 'industry-type'
	// 		this.categorymaster = data.filter(item => item.form_name === 'industry-type');
	// 		console.log(this.categorymaster)
	// 	});
	// }

	getUserGeneratedId() {
		this.userService.getUserGeneratedId().subscribe(data => {
			this.registerForm.patchValue({ user_generated_id: data });
		});
	}


	departmentRolesChange(event: any) {
		this.selectedDepartmentRoles = event;
	}

	getDepartments() {
		this.departmentService.getDepartmentsClientsRoles()
			.subscribe(
				data => {
					this.departmentsRoles = data;
					this.loadForm();
				});
	}




	// onOtpSubmit() {
	// 	if (this.otpForm.invalid) return;
	// 	const enteredOtp = this.otpForm.value.otp;
	// 	if (enteredOtp === this.otpCode) {
	// 		// Proceed with registration since OTP is valid
	// 		this.authenticationService.register(this.tempUserData).subscribe((data) => {
	// 			this.toastr.success(
	// 				this.translate.instant('register.messages.success'),
	// 				this.translate.instant('register.title')
	// 			);
	// 			this.router.navigate(['login']);
	// 		});
	// 	} else {
	// 		this.toastr.error('Invalid OTP. Please try again.');
	// 	}

	// }

	// emailKey: string = '';
	// otpVerified: boolean = false;

	// 		verifyUserOtp() {
	//   const otp = Object.values(this.otpForm.value).join('');
	//   console.log('Submitted OTP:', otp);
	// }

	verifyUserOtp() {
		if (this.otpForm.invalid) {
			console.warn('OTP form is invalid');
			return;
		}

		const otp = Object.values(this.otpForm.value).join('');
		const emailKey = this.registerForm.value.email;

		this.authenticationService.registerOtp(emailKey, otp).subscribe({
			next: (res: any) => {
				console.log('✅ OTP Response:', res);

				if (res && res.token) {
					// Save exactly like login does
					localStorage.setItem('token', res.token);
					localStorage.setItem('profile_status_percentage', res.profile_status_percentage);
					localStorage.setItem('business_account_id', res.business_account_id); // optional if OTP gives it
					this.currentTokenSubject.next(res.token);

					this.authenticationService.setLoggedUser(res.user);
					this.otpVerified = true;

					this.toastr.success(this.translate.instant('OTP VERIFIED SUCCESSFULLY'));

					// Navigate AFTER saving token
					this.router.navigate(['/dashboard']);
				} else {
					console.warn('⚠️ Invalid OTP.');
				}
			},
			error: (err) => {
				console.error('OTP verification failed:', err);
			}
		});
	}


	focusNext(event: any, nextControlName: string) {
		if (event.target.value.length === 1) {
			const nextInput = document.querySelector(`[formcontrolname="${nextControlName}"]`) as HTMLElement;
			if (nextInput) nextInput.focus();
		}
	}

	// continueGoogle() {
	// 	window.location.href = 'http://localhost:9090/oauth2/authorization/google';
	// }

	showPassword = false;

	togglePassword() {
		this.showPassword = !this.showPassword;
	}
}
